/**
 * Confirm callback for the share/activate/limit modals. The trailing userIds /
 * tagIds are supplied by the share-drawer flow; the modals themselves only pass
 * the first five.
 */
export type OnConfirmFunc = (
  resourceId: number[] | null,
  comment?: string,
  activeFrom?: Date,
  activeTo?: Date | null,
  title?: string,
  userIds?: number[],
  tagIds?: number[],
) => boolean | Promise<boolean>;

export enum PatientSharedSection {
  All = "all",
  EducationalMaterials = "educationalMaterials",
  Recipes = "recipes",
  Collections = "collections",
  Diets = "diets",
}

export enum PatientSharedSectionEmptyState {
  All = "all",
  EducationalMaterials = "educationalMaterials",
  EducationalMaterialsPdf = "educationalMaterialsPdf",
  EducationalMaterialsVideo = "educationalMaterialsVideo",
  Recipes = "recipes",
  Collections = "collections",
  Diets = "diets",
}

export enum PatientSharedHistoryType {
  All = 0,
  Recipes = 1,
  Collections = 2,
  Diets = 3,
  EducationalMaterials = 4,
}

export enum ViewTabs {
  GRID = "grid",
  LIST = "list",
}

export enum EducationalMaterialsTabs {
  TEXT_MATERIALS = "textMaterials",
  PDF_FILES = "pdfFiles",
  VIDEO_FILES = "videoFiles",
}

export enum PatientSharedIndividualSection {
  All = 0,
  ACTIVE = 1,
  SCHEDULED = 2,
  INACTIVE = 3,
}

export enum SharedStatus {
  ACTIVE = 1,
  SCHEDULED = 2,
  INACTIVE = 3,
}

export enum SharedLimits {
  COLLECTIONS = 20,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  DIETS = 20,
  EDUCATIONAL_MATERIALS = 1000,
  RECIPES = 200,
  SHARED_PANEL = 10,
}

export enum SectionCategory {
  GENERAL_INFORMATION = 1,
  HEALTH = 2,
  LIFESTYLE = 3,
  BEAUTY = 4,
  SPORT = 5,
  CULINARY = 6,
  OTHERS = 7,
}

export enum StatusTag {
  ALL = "all",
  LATEST = "latest",
  FAVORITE = "favorite",
}

export interface HistoryItem {
  id: number;
  status: { id: number };
  type: { id: number };
  createdAt?: string | null;
  /** Payload varies by history type; only the scheduled date is ever read. */
  data: { scheduledAt?: string | null; [key: string]: unknown };
}

export enum SharedPath {
  SECTIONS = "/sections",
  SHARED = "/shared",
}
